import MapFallback from "@mirage/components/MapView/components/MapFallback";
import useSessionStorage from "@mirage/hooks/useSessionStorage";
import { PPConstants } from "@shared/publicportal/constants";
import { geometry } from "@turf/helpers";
import React, { Suspense, lazy, memo, useCallback, useMemo } from "react";
import { EnabledToolTypes, TileLayerOptions } from "@mirage/components/gaiaMap/GaiaMap";
import { LatLngExpression } from "leaflet";

interface PublicPortalMapSearchProps {
    geometry?: string;
    setStateModifier: (modifier: Partial<{ geometry: string }>) => void;
}

const GaiaMap = lazy(() =>
    import("@mirage/components/gaiaMap/GaiaMap").then((module) => {
        return { default: module.GaiaMap };
    })
);

export const PublicPortalMapSearch = memo(({ setStateModifier, geometry }: PublicPortalMapSearchProps) => {
    const [sessionValue] = useSessionStorage(PPConstants.AppName);
    const { clientSettings } = sessionValue;
    const enabledToolTypes: EnabledToolTypes[] = useMemo(() => ["polygon", "delete", "circle"], []);
    const center: LatLngExpression = useMemo(() => [clientSettings.MAP_CENTER_LAT, clientSettings.MAP_CENTER_LONG], [clientSettings]);
    const onChange = useCallback(
        (geometry: string | null) => {
            setStateModifier({ geometry: geometry || "" });
        },
        [setStateModifier]
    );
    const masterLayer: TileLayerOptions | undefined = useMemo(
        () =>
            clientSettings
                ? {
                      layerUrl: clientSettings.MASTER_LAYER_URL,
                      attribution: clientSettings.MASTER_LAYER_ATTRIBUTION,
                  }
                : undefined,
        [clientSettings]
    );

    return (
        <Suspense fallback={<MapFallback />}>
            <GaiaMap center={center} geometryJson={geometry} enabledToolTypes={enabledToolTypes} onChange={onChange} tileLayer={masterLayer} height={500} zoom={7} />
        </Suspense>
    );
});
